import { TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { IconContext } from "react-icons";
import { FaApple, FaFacebook, FaGoogle, FaChevronRight } from "react-icons/fa";
import { IoCaretBack } from "react-icons/io5";
import { Link, useNavigate, useParams } from "react-router-dom";




import { toast } from "react-toastify";
import apiClient from "../../api/apiClient";
import useApi from "../../hooks/useApi";

export default () => {
  const usparam=useParams()
  const {id,token}=usparam
  let loginState = {
    new_password1: "",
    new_password2: "",
    uid:id,
    token:token
  };
  useEffect(() => {
    document.title = "RollingAdz: Sign in" || "Default Title";
  }, []);
  const navigate = useNavigate();

  const [loginData, setLoginData] = useState(loginState);


  const { request, loading, error } = useApi((data) =>
  apiClient.post(`/authentication/password-reset/confirm/${id}/${token}/`, data)
  );


      


  const handlesubmit = async(e)=>{
    e.preventDefault();



    const result = await request(loginData);
    if (!result.ok) {
      Object.keys(result.data).forEach(key => {
        const errorMessage = result.data[key][0] 
  
        toast.error(errorMessage)
       
      })
      return
    }
  
    toast.success(result.data.detail)
    navigate("/signin")

}

  const farmdata=(key,value)=>{
    setLoginData({...loginData,[key]:value})
      
      }
console.log(usparam,"usparam");
  return (
    <div>
      {/* Signup button popup */}
      <div className="main_2 d-flex justify-content-center align-items-center py-5">
        <form  onSubmit={handlesubmit} className="signin-box p-2 rounded-3 col-md-3">
     
 
    

     <h2 className="text-center mt-1 mb-1">Forget <br /> Password</h2>
     <div class="horizontal-line mx-auto mb-4"></div>

      <div className="d-flex flex-column justify-conetent-center mx-5  ">
 
      <TextField onChange={(e)=>farmdata("new_password1",e.target.value)} className="my-3" id="outlined-basic" label="New Password" variant="outlined" />
      <TextField onChange={(e)=>farmdata("new_password2",e.target.value)} id="outlined-basic" label="confirm  New Password" variant="outlined" />

      <button className="btn text-light mb-3 mt-4 mx-auto rounded-4 py-1" style={{backgroundColor:"#015A96",width:"170px"}}>  Update </button>
      </div>
     
   

        </form>
      </div>
    </div>
  );
};

// function SignUp({ items }) {
//   const { navigate, type, setType } = items;

//   return (
//     <div
//       className="tab-pane fade"
//       id="pills-signup"
//       role="tabpanel"
//       aria-labelledby="pills-signup-tab"
//     >
//       {!type && (
//         <form action>
//           <div className=" row justify-content-center">
//             <div className="col-md-6">
//               <div className="py-3">
//                 <h5 className="text_color text-center">
//                   Become a Rolling Adz Advertiser
//                 </h5>
//                 <div className="d-flex justify-content-center">
//                   <button
//                     onClick={() => {
//                       setType(1);
//                     }}
//                     className="btn btn_bg px-5 rounded-pill"
//                     id="pills-signup-tab"
//                     data-bs-toggle="pill"
//                     data-bs-target="#pills-button"
//                     type="button"
//                     role="tab"
//                     aria-controls="pills-signup"
//                     aria-selected="false"
//                   >
//                     <h5>Advertiser</h5>
//                     <p>(Agencies & Companies)</p>
//                   </button>
//                 </div>
//               </div>

//               <div className="py-3">
//                 <h5 className="text_color text-center">
//                   Become a Rolling Adz Vendor
//                 </h5>
//                 <div className="d-flex justify-content-center">
//                   <button
//                     onClick={() => {
//                       setType(2);
//                     }}
//                     className="btn btn_bg px-5 rounded-pill"
//                     type="button"
//                   >
//                     <h5>Vendors</h5>
//                     <p>(Vehicle,Installer,etc.)</p>
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </form>
//       )}
//       {type == 1 && (
//         <form action>
//           <div className=" row justify-content-center">
//             <div className="col-md-6">
//               <h3 className="text_color text-center text-decoration-underline">
//                 Advertisers
//               </h3>
//               <div className="py-3">
//                 <h5 className="text_color text-center">Are you an agency?</h5>
//                 <div className="d-flex justify-content-center">
//                   <button
//                     style={{ width: "300px" }}
//                     onClick={() =>
//                       navigate("/signUpPopup", { state: { role: "AG" } })
//                     }
//                     className="btn btn_bg rounded-pill fs-3 px-5 lh-lg"
//                     id="pills-signup-tab"
//                     data-bs-toggle="pill"
//                     data-bs-target="#pills-button"
//                     type="button"
//                     role="tab"
//                     aria-controls="pills-signup"
//                     aria-selected="false"
//                   >
//                     Agency
//                   </button>
//                 </div>
//               </div>

//               <div className="py-3">
//                 <h5 className="text_color text-center">
//                   Are you a company direct?
//                 </h5>
//                 <div className="d-flex justify-content-center">
//                   <button
//                     style={{ width: "300px" }}
//                     onClick={() =>
//                       navigate("/signUpPopup", { state: { role: "CD" } })
//                     }
//                     className="btn btn_bg rounded-pill fs-3 px-5 lh-lg"
//                     type="button"
//                   >
//                     Company Direct
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </form>
//       )}
//       {type == 2 && (
//         <form action>
//           <h3 className="text_color text-center text-decoration-underline">
//             Vendors
//           </h3>

//           <div className=" row">
//             <div className="col-md-6">
//               <div className="py-3">
//                 <h5 className="text_color text-center">List your Vehicle!</h5>
//                 <div className="d-flex justify-content-center">
//                   <button
//                     onClick={() =>
//                       navigate("/signUpPopup", { state: { role: "VO" } })
//                     }
//                     className="btn btn_bg rounded-pill fs-3 px-5 lh-lg"
//                     type="button"
//                   >
//                     Vehicle Owner
//                   </button>
//                 </div>
//               </div>
//             </div>

//             <div className="col-md-6">
//               <div className="py-3">
//                 <h5 className="text_color text-center">
//                   Become a Rolling Adz Installer!
//                 </h5>
//                 <div className="d-flex justify-content-center">
//                   <button
//                     onClick={() =>
//                       navigate("/signUpPopup", { state: { role: "IN" } })
//                     }
//                     className="btn btn_bg rounded-pill fs-3 px-5 lh-lg"
//                     type="button"
//                   >
//                     Installer
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className=" row">
//             <div className="col-md-6">
//               <div className="py-3">
//                 <h5 className="text_color text-center">
//                   Become a Rolling Adz <br /> Designer!
//                 </h5>
//                 <div className="d-flex justify-content-center">
//                   <button
//                     onClick={() =>
//                       navigate("/signUpPopup", { state: { role: "DE" } })
//                     }
//                     className="btn btn_bg rounded-pill fs-3 px-5 lh-lg"
//                     id="pills-signup-tab"
//                     data-bs-toggle="pill"
//                     data-bs-target="#pills-button"
//                     type="button"
//                     role="tab"
//                     aria-controls="pills-signup"
//                     aria-selected="false"
//                   >
//                     Designer
//                   </button>
//                 </div>
//               </div>
//             </div>

//             <div className="col-md-6">
//               <div className="py-3">
//                 <h5 className="text_color text-center">
//                   Become a Rolling Adz Phototgrapher!
//                 </h5>
//                 <div className="d-flex justify-content-center">
//                   <button
//                     onClick={() =>
//                       navigate("/signUpPopup", { state: { role: "PH" } })
//                     }
//                     className="btn btn_bg rounded-pill fs-3 px-5 lh-lg"
//                     type="button"
//                   >
//                     Phototgrapher
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className=" d-flex justify-content-center">
//             <div>
//               <div className="py-3">
//                 <h5 className="text_color text-center">Other Vendor!</h5>
//                 <div className="d-flex justify-content-center">
//                   <button
//                     // onClick={()=>navigate('/signUpPopup',{state:{id:3}})}

//                     className="btn btn_bg rounded-pill fs-3 px-5 lh-lg"
//                     type="button"
//                     role="tab"
//                     aria-controls="pills-signup"
//                     aria-selected="false"
//                   >
//                     Other:
//                     <input
//                       type="text"
//                       className=" btn_bg"
//                       style={{ borderBottomWidth: 2 }}
//                     />
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </form>
//       )}
//     </div>
//   );
// }
